import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Custom hook for smooth scrolling to page sections
 * Handles both same-page scrolling and cross-page navigation with scrolling
 */
export function useScrollTo() {
  const navigate = useNavigate();

  /**
   * Scroll to an element by ID on the current page
   */
  const scrollToElement = useCallback((elementId: string) => {
    // Use requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(() => {
      document.getElementById(elementId)?.scrollIntoView({ behavior: "smooth" });
    });
  }, []);

  /**
   * Navigate to a different page and scroll to an element
   */
  const navigateAndScroll = useCallback((path: string, elementId: string) => {
    navigate(path);
    // Small delay to allow route transition and DOM render
    setTimeout(() => {
      scrollToElement(elementId);
    }, 100);
  }, [navigate, scrollToElement]);

  return { scrollToElement, navigateAndScroll };
}
